export const RepeatableQcFieldName = 'repeatableGroupQcFieldComponent';
